module.exports = __webpack_public_path__ + "img/deluxe-filter-welcome-background-cjdr.079cc059.jpg";